<template>
  <div>
    <p class="mb-5 text-[14px] leading-[22px] text-gray-800">
      Please report any issues or feedback you experienced with your
      {{ subject }}
    </p>
    <Textarea
      :model-value="modelValue"
      label="Your feedback"
      placeholder="Your feedback"
      @update:model-value="emit('update:modelValue', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import { Textarea } from '@dacr/library'

withDefaults(defineProps<{ modelValue: string; subject?: string }>(), {
  subject: 'report',
})
const emit = defineEmits<{ 'update:modelValue': [value: string] }>()
</script>
